import React, { useEffect, useState } from 'react';
import { AndroidOutlined, AppleOutlined } from '@ant-design/icons';
import { Table, Input, Button, Space, Tabs } from 'antd';
import axios from 'axios';
import ProgrammeService from '../../api/programme.service';
import { SUCCESS_STATUS } from '../../utility/Constants';
import commonUtility from '../../utility/Utils';

const { Column } = Table;

const { TabPane } = Tabs;

const OpeningBalanceEntryView = () => {
  const [programWiseMemberList,setProgramWiseMemberList] = useState([]);
  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);



  const handleTabChange = (activeKey) => {
    console.log("Active Tab Key:", activeKey);
    getMemberList(activeKey)
    // Perform any desired action based on the active tab key
  };

  useEffect(()=>{
    getMemberList("JCP");
  },[])
  




  const handleOpeningBalanceChange = (value, record) => {
    commonUtility.allowOnlyNumber(value);
    console.log('commonUtility.value',value);
    console.log('commonUtility.allowOnlyNumber',commonUtility.allowOnlyNumber(value));

    if(commonUtility.allowOnlyNumber(value) != ""){
      setProgramWiseMemberList(prevData => {
        const newData = [...prevData];
        const index = newData.findIndex(item => item.enrollment_id === record.enrollment_id);
        newData[index].opening_balance = commonUtility.allowOnlyNumber(value);
        newData[index].isSaved = false;
        return newData;
      });
    }
    
  };



  const handleSave = async (values) => {


    const formdValues = {
        enrollment_id: values.enrollment_id == undefined ? '' : values.enrollment_id,
        opening_id: values.opening_id == undefined ? '' : values.opening_id,
        opening_balance: values.opening_balance == undefined ? '' : values.opening_balance,
        
    }
    
    const data = { formdata: formdValues };
    ProgrammeService.openingBalanceAction(data).then((res) => {
      console.log('res.data.response_status',res.data.response_status);

        if(res.data.response_status == SUCCESS_STATUS){
          setProgramWiseMemberList(prevData => {
            const newData = [...prevData];
            const index = newData.findIndex(item => item.enrollment_id === values.enrollment_id);
            newData[index].isSaved = true;
            return newData;
          });
        }
        else{
           
        }
       // setIsDataUpdated(!isDataUpdated)
    });
  };




  const getMemberList = (short_code) => {

    setProgramWiseMemberList([]);

    const data = { formdata: {
        programme_id:short_code
    }};

    ProgrammeService.memberListWithOpeningBalance(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setProgramWiseMemberList(res.data.response_data);
      }
    });
  }

  const columns = [
    { 
      title: '#', 
      dataIndex: 'index', 
      render: (text, record, index) => (page - 1) * 10 + ++index ,
      width: '5%',
    },
   
    {
      title: 'Code',
      dataIndex: 'member_code',
      key: 'member_code',
      sorter: (a, b) => a.member_code.localeCompare(b.member_code),

    }, 
    
   
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj,record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),

    },


    {
      title: 'Primary Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
      sorter: (a, b) => a.primary_mobile - b.primary_mobile,
    },

    {
      title: 'Validity',
      dataIndex: 'enrollment_start_date',
      key: 'enrollment_start_date',
      render: (selectedObj,record) => (
        <Space style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis',fontWeight:600 }}>
            <span>{record.enrollment_start_date} to {record.enrollment_end_date}</span>
        </Space>
      ),
    },

    {
      title: 'Opening Balance',
      dataIndex: 'opening_balance',
      key: 'opening_balance',
      render : (text, record) => (
        <Input
          style={{width:'100px',borderRadius:'8px',textAlign:'right'}}
          value={text}
          onChange={e => handleOpeningBalanceChange(e.target.value, record)}
        />
      )
    },

    {
      title: 'Action',
      dataIndex: 'actions',
      key: 'actions',
      render:(text, record) => (
        <>
          {record.isSaved ? <> <Button shape="round" size="small" onClick={() => handleSave(record)} 
          style={{
            background:'#22861a', 
            border:'1px solid #22861a',
            color:"#F0FFDA",
            width:"90px",
            height:"28px"
          }}>Updated</Button> </> : <> 
          <Button 
          shape="round"
          size="small" 
          type="primary" 
          style={{
            width:"90px",
            height:"28px"
          }}
          onClick={() => handleSave(record)}>Save</Button></>}
        </>
       
      )
    },

  ];






  return (
    // <div>

    //   <Table dataSource={programWiseMemberList} columns={columns} pagination={false} size='small'></Table>
      
    // </div>

    <div style={{boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',padding:'4px 10px'}}>
    <Tabs defaultActiveKey="JCP" onChange={handleTabChange} className='custom-tabs'>
      {/* Tab 1 */}
      <TabPane tab="Junior Coaching Programme (JCP)" key="JCP">
        <Table key={`JCP${commonUtility.randomID()}`} dataSource={programWiseMemberList} columns={columns} pagination={false} size='small'></Table>
      </TabPane>

      {/* Tab 2 */}
      <TabPane tab="High Performance (HP)" key="HP">
        <Table key={`HP${commonUtility.randomID()}`} dataSource={programWiseMemberList} columns={columns} pagination={false} size='small'></Table>
      </TabPane>

      {/* Tab 3 */}
      <TabPane tab="Physicall Fitness (PF)" key="PF">
        <Table key={`PF${commonUtility.randomID()}`} dataSource={programWiseMemberList} columns={columns} pagination={false} size='small'></Table>
      </TabPane>
    </Tabs>
    </div>
  );
}

export default OpeningBalanceEntryView;
